module.exports = __webpack_public_path__ + "static/media/app-store-badge-es.4f27d83a.png";